module.exports = __webpack_public_path__ + "static/media/71R3oboi-EL._AC_SL1500_.cd3123ee.jpg";